import API from '@/api'
import axiosInstance from '@/api/api'
import storage from '@/utils/localStorage'

export const moduleName = 'auth'

export const actionTypes = {
  ACTION_INIT_WS: 'ACTION_INIT_WS',
  ACTION_READ_ALL_NOTIFICAITONS: 'ACTION_READ_ALL_NOTIFICAITONS',
  ACTION_READ_NOTIFICAITON: 'ACTION_READ_NOTIFICAITON',
  ACTION_LOAD_NOTIFICAITONS: 'ACTION_LOAD_NOTIFICAITONS',
  ACTION_SIGN_IN: 'ACTION_SIGN_IN',
  ACTION_FORGOT_PASSWORD: 'ACTION_FORGOT_PASSWORD',
  ACTION_SIGN_OUT: 'ACTION_SIGN_OUT',
  ACTION_FETCH_USER: 'ACTION_FETCH_USER',
  ACTION_CHANGE_USER_PROFILE: 'ACTION_CHANGE_USER_PROFILE',
  ACTION_UPLOAD_USER_PHOTO: 'ACTION_UPLOAD_USER_PHOTO',
  ACTION_ADD_USER: 'ACTION_ADD_USER',
  ACTION_VERIFY_RESET_PASSWORD_TOKEN: 'ACTION_VERIFY_RESET_PASSWORD_TOKEN',
  ACTION_RESET_USER_PASSWORD: 'ACTION_RESET_USER_PASSWORD'
}

export const getterTypes = {
  GETTER_USER: 'GETTER_USER',
  GETTER_IS_AUTHENTICATED: 'GETTER_IS_AUTHENTICATED',
  GETTER_NOTIFICATIONS: 'GETTER_NOTIFICATIONS',
  GETTER_UNREADED_NOTIFICATIONS_COUNT: 'GETTER_UNREADED_NOTIFICATIONS_COUNT',
  GETTER_PAGE_RELOAD: "GETTER_PAGE_RELOAD",
  GETTER_SITE_CONFIG: "GETTER_SITE_CONFIG"
}

export const mutationTypes = {
  MUTATION_SET_USER: 'MUTATION_SET_USER',
  MUTATION_SET_NOTIFICATIONS: 'MUTATION_SET_NOTIFICATIONS',
  MUTATION_SET_PAGE_RELOAD: 'MUTATION_SET_PAGE_RELOAD',
  MUTATION_SET_SITE_CONFIG: 'MUTATION_SET_SITE_CONFIG',

}

export default {
  moduleName,

  namespaced: true,

  state: () => ({
    user: {},
    notifications: [],
    isPageReload: false,
    siteConfig: []
  }),

  actions: {
    [actionTypes.ACTION_INIT_WS] ({ commit }) {
      const onUpdateNotification = (notifications) => {
        commit(mutationTypes.MUTATION_SET_NOTIFICATIONS, notifications)
      }
      API.user.wsListeners[API.user.wsEvents.notifications](onUpdateNotification)
    },

    [actionTypes.ACTION_READ_ALL_NOTIFICAITONS] ({ commit, getters }) {
      const ids = getters[getterTypes.GETTER_NOTIFICATIONS].map(n => n.id)
      if (ids.length > 0) {
        API.user.wsActions.ACTION_READ_NOTIFICATION({ ids })
      }
    },

    [actionTypes.ACTION_READ_NOTIFICAITON] ({ commit }, notification) {
      if (notification && notification.id) {
        API.user.wsActions.ACTION_READ_NOTIFICATION({ ids: [notification.id] })
      }
    },

    async [actionTypes.ACTION_SIGN_IN] ({ commit }, payload) {
      const res = await API.auth.login(payload)
      commit(mutationTypes.MUTATION_SET_USER, res.data.user)
      storage.setToken(res.data.token)
      axiosInstance.defaults.headers.common['Authorization'] = res.data.token // eslint-disable-line
    },

    async [actionTypes.ACTION_FORGOT_PASSWORD] ({ commit }, payload) {
      const res = await API.auth.forgotPassword(payload)
      commit(mutationTypes.MUTATION_SET_USER, res.data.user)
      return true
    },
    async [actionTypes.ACTION_RESET_USER_PASSWORD]({ }, payload) {
      await API.auth.resetPassword( payload)
    },
    async [actionTypes.ACTION_VERIFY_RESET_PASSWORD_TOKEN]({ }, payload) {
      await API.auth.verifyResetPasswordToken(payload)
    },

    async [actionTypes.ACTION_SIGN_OUT] ({ commit }) {
      storage.cleanAll()
    },

    async [actionTypes.ACTION_FETCH_USER] ({ commit }) {
      const res = await API.auth.fetchUser()
      const response = await API.carManager.getSiteConfigByModule()
      commit(mutationTypes.MUTATION_SET_USER, res.data)
      const config = response.data?.data || [];
      console.log("config",config)
      commit(mutationTypes.MUTATION_SET_SITE_CONFIG, config)
    },

    async [actionTypes.ACTION_LOAD_NOTIFICAITONS] ({ commit }) {
      const notifications = await API.user.getUserNotifications()
      commit(mutationTypes.MUTATION_SET_NOTIFICATIONS, notifications.data)
    },

    async [actionTypes.ACTION_UPLOAD_USER_PHOTO] (_, payload) {
      await API.user.uploadUserPhoto(payload)
    },

    async [actionTypes.ACTION_CHANGE_USER_PROFILE] ({commit}, payload) {
      await API.user.editProfile(payload)
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true);

    },

    async [actionTypes.ACTION_ADD_USER] ({commit}, payload) {
      const res =  await API.user.add(payload)
      commit(mutationTypes.MUTATION_SET_PAGE_RELOAD, true);
      return res
    }
  },

  mutations: {
    [mutationTypes.MUTATION_SET_USER] (state, value) {
      state.user = value
    },
    [mutationTypes.MUTATION_SET_NOTIFICATIONS] (state, notifications) {
      state.notifications = notifications
    },
    [mutationTypes.MUTATION_SET_PAGE_RELOAD](state, pageReload) {
      state.isPageReload = pageReload;
    },
    [mutationTypes.MUTATION_SET_SITE_CONFIG] (state, value) {
      console.log("MUTATION_SET_SITE_CONFIG", value)
      state.siteConfig = value;    
    },
  },

  getters: {
    [getterTypes.GETTER_USER]: (state) => state.user,
    [getterTypes.GETTER_IS_AUTHENTICATED]: (state) => Boolean(state.user && state.user.id),
    [getterTypes.GETTER_NOTIFICATIONS]: (state) => state.notifications,
    [getterTypes.GETTER_UNREADED_NOTIFICATIONS_COUNT]: (state) => state.notifications.reduce((count, nh) => nh.unreadedCount + count, 0),
    [getterTypes.GETTER_PAGE_RELOAD]: (state) => state.isPageReload,
    [getterTypes.GETTER_SITE_CONFIG]: (state) => state.siteConfig,

  }
}
